module.exports = __webpack_public_path__ + "img/grip-lines.e8761530.svg";